/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { VehicleMovementType } from './VehicleMovementType';
import {
    VehicleMovementTypeFromJSON,
    VehicleMovementTypeFromJSONTyped,
    VehicleMovementTypeToJSON,
    VehicleMovementTypeToJSONTyped,
} from './VehicleMovementType';

/**
 * See [`VehicleMovement`] for information on the individual fields.
 * @export
 * @interface VehicleMovementCreate
 */
export interface VehicleMovementCreate {
    /**
     * 
     * @type {string}
     * @memberof VehicleMovementCreate
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleMovementCreate
     */
    vehicleId: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleMovementCreate
     */
    userId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleMovementCreate
     */
    periodId: string;
    /**
     * 
     * @type {Date}
     * @memberof VehicleMovementCreate
     */
    time: Date;
    /**
     * 
     * @type {VehicleMovementType}
     * @memberof VehicleMovementCreate
     */
    movementType: VehicleMovementType;
}



/**
 * Check if a given object implements the VehicleMovementCreate interface.
 */
export function instanceOfVehicleMovementCreate(value: object): value is VehicleMovementCreate {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('vehicleId' in value) || value['vehicleId'] === undefined) return false;
    if (!('periodId' in value) || value['periodId'] === undefined) return false;
    if (!('time' in value) || value['time'] === undefined) return false;
    if (!('movementType' in value) || value['movementType'] === undefined) return false;
    return true;
}

export function VehicleMovementCreateFromJSON(json: any): VehicleMovementCreate {
    return VehicleMovementCreateFromJSONTyped(json, false);
}

export function VehicleMovementCreateFromJSONTyped(json: any, ignoreDiscriminator: boolean): VehicleMovementCreate {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'vehicleId': json['vehicleId'],
        'userId': json['userId'] == null ? undefined : json['userId'],
        'periodId': json['periodId'],
        'time': (new Date(json['time'])),
        'movementType': VehicleMovementTypeFromJSON(json['movementType']),
    };
}

export function VehicleMovementCreateToJSON(json: any): VehicleMovementCreate {
    return VehicleMovementCreateToJSONTyped(json, false);
}

export function VehicleMovementCreateToJSONTyped(value?: VehicleMovementCreate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'vehicleId': value['vehicleId'],
        'userId': value['userId'],
        'periodId': value['periodId'],
        'time': value['time'].toISOString(),
        'movementType': VehicleMovementTypeToJSON(value['movementType']),
    };
}

